<form class="form-container" [formGroup]="form">
    <h2 mat-dialog-title>{{ 'DROP_COMPLAINT' | translate }}</h2>
    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-12 text-center">
                <img src="assets/images/drop-1.svg" class="drop-icon" alt="">
                <!-- <h3 class="action-title">{{'DROP_COMPLAINT' | translate}}</h3> -->
              </div>
            <div class="col-12 text-center">
                <mat-label>{{'DROP_CONFIRMATION_TEXT' | translate}}</mat-label>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'COMMENTS' | translate}} </mat-label>
                    <textarea matInput formControlName="comment"></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
            <button mat-raised-button [disabled]="form.invalid" (click)="drop()" [mat-dialog-close]="form.value" color="primary"
                    cdkFocusInitial>{{'YES_DROP' | translate}} </button>
            <button mat-raised-button mat-dialog-close>{{'CALCEL' | translate}}</button>
    </mat-dialog-actions>
</form>